export default __webpack_public_path__ + "bd2e684413d5b55d84721044a44290e3.png";